import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email, name: name.trim() || null });
      toast.success("Welcome aboard — the next dispatch arrives soon.");
      setEmail(""); setName("");
    } catch (err) {
      toast.error(err?.response?.data?.detail?.[0]?.msg || "Could not subscribe. Try again.");
    } finally { setLoading(false); }
  };

  return (
    <footer className="mt-32 bg-ink text-bg" data-testid="site-footer">
      <div className="max-w-8xl mx-auto px-6 md:px-12 py-20 md:py-28 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <div className="font-serif text-5xl md:text-7xl leading-[0.95]">Where to go<br/>next.</div>
          <p className="mt-8 max-w-md text-sm leading-relaxed text-bg/70">
            Travel guides, magazines and articles delivered to your inbox a few times a year. Keep in touch and keep informed.
          </p>
        </div>
        <div className="md:col-span-6">
          <form onSubmit={subscribe} className="border border-bg/30 p-6 md:p-8" data-testid="footer-newsletter-form">
            <div className="overline text-bg/60 mb-3">The Newsletter</div>
            <div className="font-serif text-2xl mb-5">Subscribe here for our latest travel updates.</div>
            <div className="flex flex-col gap-3">
              <input value={name} onChange={e => setName(e.target.value)} type="text" placeholder="Your name (optional)" className="w-full bg-transparent border border-bg/30 px-4 py-3 outline-none focus:border-bg placeholder:text-bg/40 text-bg" data-testid="footer-newsletter-name-input"/>
              <div className="flex flex-col sm:flex-row gap-3">
                <input value={email} onChange={e => setEmail(e.target.value)} type="email" required placeholder="you@somewhere.com" className="flex-1 bg-transparent border border-bg/30 px-4 py-3 outline-none focus:border-bg placeholder:text-bg/40 text-bg" data-testid="footer-newsletter-input"/>
                <button disabled={loading} type="submit" className="bg-bg text-ink px-6 py-3 text-[0.78rem] uppercase tracking-[0.18em] font-semibold hover:bg-ochre hover:text-ink transition-colors disabled:opacity-50" data-testid="footer-newsletter-submit">{loading ? "Sending…" : "Subscribe"}</button>
              </div>
            </div>
          </form>
          <div className="grid grid-cols-2 gap-6 mt-10 text-sm">
            <div>
              <div className="overline text-bg/60 mb-3">Explore</div>
              <ul className="space-y-2">
                <li><Link to="/" className="hover:text-ochre">Home</Link></li>
                <li><Link to="/destinations" className="hover:text-ochre">Destinations</Link></li>
                <li><Link to="/map" className="hover:text-ochre">Map</Link></li>
                <li><Link to="/about" className="hover:text-ochre">About</Link></li>
              </ul>
            </div>
            <div>
              <div className="overline text-bg/60 mb-3">Follow</div>
              <ul className="space-y-2">
                <li><a href="mailto:thewheretogo@btinternet.com" className="hover:text-ochre">Email</a></li>
                <li><a href="https://www.youtube.com/@thewheretogo" target="_blank" rel="noreferrer" className="hover:text-ochre">YouTube</a></li>
                <li><a href="https://www.instagram.com/thewheretogo2025" target="_blank" rel="noreferrer" className="hover:text-ochre">Instagram</a></li>
                <li><a href="https://www.facebook.com/TheWhereToGo" target="_blank" rel="noreferrer" className="hover:text-ochre">Facebook</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-bg/10">
        <div className="max-w-8xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-xs text-bg/50">
          <div>© {new Date().getFullYear()} The Where To Go. All articles by the editor.</div>
          <div className="overline">Documentary travel · est. 2022</div>
        </div>
      </div>
    </footer>
  );
}
